import { ProcessCellForExportParams } from 'ag-grid-community';
import { get } from 'lodash';

export class AssetVariableCellHelpers {
  static processValue(params: ProcessCellForExportParams): string {
    const { column, node, value } = params;
    return get(value, 'name') ?? get(node, `data.${column.getColDef().field}`, '');
  }
}
